import { QueryClient } from '@tanstack/react-query';
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            enabled: true,
            refetchInterval: false,
            refetchIntervalInBackground: false,
            refetchOnWindowFocus: true,
            refetchOnReconnect: true,
            refetchOnMount: true,
            retryOnMount: true,
            // suspense: true,
        },
        mutations: {
            onError: (_error) => {
                //
            },
        },
    },
});
//# sourceMappingURL=queryClient.js.map